import { render } from "./QuizImageChoices.vue?vue&type=template&id=31074ec8"
import script from "./QuizImageChoices.vue?vue&type=script&lang=js"
export * from "./QuizImageChoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__